import React from 'react';
import { Star, Scissors, Sparkles, Award } from 'lucide-react';

const Team = () => {
  const teamMembers = [
    {
      name: 'Yohan',
      role: 'Senior Hair Stylist',
      rating: 5.0,
      icon: Award,
      image: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/1473703/medium/4d37f83f-0c5a-48fa-8765-8145fa8cc740-IMG_1336_jpg.jpeg',
      description: 'Expert senior stylist specializing in precision balayage techniques and custom color transformations.',
      specialties: ['Balayage', 'Color Correction', 'Precision Cuts'],
      bookingUrl: 'https://www.fresha.com/p/yohan-flores-5780371',
    },
    {
      name: 'Bailee',
      role: 'Hair Stylist / Curly Specialist',
      rating: 5.0,
      icon: Sparkles,
      image: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/1456850/medium/a7c24204-cf43-4da5-aff8-4343848b7456-AirBrush_20250321141848.jpg',
      description: 'Passionate about creating natural, sun-kissed looks with expertise in curly hair and dimensional color.',
      specialties: ['Balayage', 'Curly Hair', 'Dimensional Color'],
      bookingUrl: 'https://www.fresha.com/p/bailee-s-5552485',
    },
    {
      name: 'Taylor',
      role: 'Senior Hair Stylist / Long Hair Specialist',
      rating: 5.0,
      icon: Sparkles,
      image: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/1540756/medium/9385f5d8-abd7-41dc-ac47-2f3f3d1c7019-123_1.jpeg',
      description: 'Long-hair specialist creating signature big bouncy blowouts, luminous balayage, and seamless colour corrections.',
      specialties: ['Long Hair', 'Balayage', 'Highlights', 'Colour Correction', 'Blowouts'],
      bookingUrl: 'https://www.fresha.com/p/taylor-batchelor-6336944',
    },
    {
      name: 'Arina',
      role: 'Senior Hair Stylist',
      rating: 4.8,
      icon: Scissors,
      image: 'https://cdn-partners-api.fresha.com/employee-avatars/processed/1480592/medium/883ba12d-ee14-43a7-a04e-47830c44554d-IMG_2229.jpeg',
      description: 'Senior stylist with meticulous attention to detail, specializing in transformative color and styling.',
      specialties: ['Balayage', 'Highlights', 'Toning'],
      bookingUrl: 'https://www.fresha.com/p/arina-3582145',
    },
  ];

  return (
    <section id="team" className="section-padding bg-gradient-to-b from-black via-[#0a0a0a] to-black relative">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#c9a961] text-sm font-semibold tracking-[0.2em] uppercase">Our Team</span>
          </div>
          <h2 className="font-['Playfair_Display'] text-5xl md:text-6xl font-light text-[#f8f6f0] mb-6">
            Meet Your
            <span className="block text-[#c9a961]">Colour Specialists</span>
          </h2>
          <p className="text-[#f8f6f0]/70 text-lg max-w-2xl mx-auto">
            Our talented team at Prép Beauty Parlour brings decades of combined experience in luxury hair coloring and styling.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-[#1a1a1a] to-black border border-[#c9a961]/20 overflow-hidden hover:border-[#c9a961]/40 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_0_40px_rgba(201,169,97,0.2)]"
            >
              {/* Team Member Image */}
              <div className="relative h-80 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                
                {/* Rating Badge */}
                <div className="absolute top-4 right-4 bg-black/80 backdrop-blur-sm border border-[#c9a961]/30 px-3 py-1.5 flex items-center space-x-1">
                  <Star className="text-[#c9a961]" size={14} fill="#c9a961" />
                  <span className="text-[#f8f6f0] text-sm font-semibold">{member.rating}</span>
                </div>
              </div>

              <div className="p-8">
                <h3 className="font-['Playfair_Display'] text-3xl text-[#f8f6f0] mb-2">{member.name}</h3>
                <p className="text-[#c9a961] text-sm mb-4 font-medium">{member.role}</p>
                <p className="text-[#f8f6f0]/70 text-sm leading-relaxed mb-6">{member.description}</p>
                
                <div className="flex flex-wrap gap-2 mb-6">
                  {member.specialties.map((specialty, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-[#c9a961]/10 border border-[#c9a961]/30 text-[#c9a961] text-xs"
                    >
                      {specialty}
                    </span>
                  ))}
                </div>

                <button
                  data-testid={`team-book-${member.name.toLowerCase()}`}
                  onClick={() => window.open(member.bookingUrl, '_blank')}
                  className="w-full bg-gradient-to-r from-[#c9a961] to-[#8b6f3e] hover:from-[#d4af37] hover:to-[#c9a961] text-black font-semibold py-3 px-6 rounded-none transition-all duration-300 hover:shadow-[0_0_30px_rgba(201,169,97,0.4)] hover:scale-105"
                >
                  Book with {member.name}
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center bg-gradient-to-br from-[#1a1a1a] to-black border border-[#c9a961]/30 p-12">
          <h3 className="font-['Playfair_Display'] text-3xl text-[#f8f6f0] mb-4">
            Located in Downtown Vancouver
          </h3>
          <p className="text-[#f8f6f0]/70 mb-2">1305 Burrard St, Vancouver</p>
          <p className="text-[#f8f6f0]/60 text-sm">
            Within walking distance of the West End, Yaletown, Davie Village, and Kitsilano
          </p>
        </div>
      </div>
    </section>
  );
};

export default Team;
